@mixin clearfix() {
  &::after {
    display: block;
    clear: both;
    content: "";
  }
}
